export default (widthArr) => widthArr.reduce((acc, curr) => acc + curr, 0);
